<template>
	<v-container>
		<Snackbar v-if="errored" msg="Error from Server" />
		<Snackbar v-if="deleted" msg="Operation Successfull" />		
		<v-dialog v-model="create" width="75%">
			<v-card>
				<NewDataset ref="createDialog"/>
			</v-card>
		</v-dialog>
		<v-dialog v-model="edit" width="75%">
			<v-card>
				<EditDataset :editId="editId" ref="editDialog"/>
			</v-card>
		</v-dialog>			
		<v-card-title>
			Datasets
			<v-spacer></v-spacer>
			<v-text-field
				v-model="search"
				append-icon="mdi-magnify"
				label="Search"
				single-line
				hide-details
			></v-text-field>
			<v-btn
				color="success"
				class="ml-8"
				@click="create = !create"
			>
				New
				<v-icon class="ms-2">
					mdi-plus
				</v-icon>
			</v-btn>			
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="datasets"
			:search="search"
			class="elevation-1"
		>
			<template v-slot:[`item.link`]="{ item }">
				<v-btn
					small
					icon
					color="primary"
					class="ms-2"
					:href="item.link"
				>
					<v-icon>mdi-link</v-icon>
				</v-btn>				
			</template>	
			<template v-slot:[`item.actions`]="{ item }">
				<v-tooltip left>
					<template v-slot:activator="{ on, attrs }">                
						<v-btn
							small
							icon
							color="primary"
							class="ms-2"
							v-bind="attrs"
							v-on="on"
							@click="(editId = item._id) && (edit = !edit)"
						>
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</template>
					<span> Edit </span>
				</v-tooltip>                
				<v-tooltip right>
					<template v-slot:activator="{ on, attrs }">                
						<v-btn
							small
							icon
							color="error"
							class="ms-2"
							v-bind="attrs"
							v-on="on"
							@click="confirmDelete() && deleteDataset(item)"
						>
							<v-icon>mdi-delete</v-icon>
						</v-btn>
					</template>
					<span> Delete </span>
				</v-tooltip>
			</template>			
		</v-data-table>
	</v-container>
</template>

<script>
import axios from '../../plugins/axios'
import Snackbar from '@/components/Snackbar.vue'
import NewDataset from '../Datasets/New.vue'
import EditDataset from '../Datasets/Edit.vue'

export default {
  name: 'Datasets',
	components: {
		Snackbar,
		NewDataset,
		EditDataset
	},	
  data: () => ({
    loading: true,
    errored: false,
    deleted: false,	
		create: false,
		edit: false,
		editId: null,
    datasets: [],
		search: '',
		expanded: [],
		headers: [
			{ text: 'Title', value: 'name', width: '20%', align: 'start' },
			{ text: 'Description', value: 'description', width: '30%', align: 'start' },
			{ text: 'Version', value: 'version', width: '10%', align: 'start' },
			{ text: 'Link', value: 'link', width: '10%', align: 'start' },
			{ text: 'Tags', value: 'tags', width: '20%', align: 'start' },
			{ text: 'Actions', value: 'actions', sortable: false, align: 'center', width: '10%' },
		]
  }),
	mounted() {
		this.getDatasets();
	},
	methods: {
		formateTags(tags){
			let allTags = '';
			for(var i=0; i<tags.length; i++){
				allTags += tags[i];
				if(tags[i+1]){
					allTags += ", ";
				}
			}
			return allTags;
		},

		formateDatasets(){
			this.datasets.forEach(e => {
				e.tags = this.formateTags(e.tags);
			});
			return;
		},

		getDatasets(){
			axios
			.get(`/dataset/`)
			.then(res => {
				this.datasets = res.data.data;
				this.formateDatasets();
			})
			.catch(err => {
				console.error("axios err", err);
				this.errored = true;
			})
			.finally(() => this.loading = false);
		},

		confirmDelete(){
			return confirm("Are you sure you want to delete this dataset?");
		},

		deleteDataset(dataset) {
			axios
			.delete(`/dataset/`, {data: {_id: dataset._id}})
			.then(() => {
        this.deleted = true
				this.getDatasets();
			})
			.catch(err => {
				console.error("error", err);
				this.errored = true;
			})
			.finally(() => {
				this.loading = false;
			});
		}
	},
	watch: {
		create: function(){
			if(!this.create){
				this.getDatasets();
				this.$refs.createDialog.reset();
			}
		},

		edit: function(){
			if(!this.edit){
				this.getDatasets();
				this.editId = null;
				this.$refs.editDialog.reset();
			}
		}
	}	
}
</script>

<style>

</style>